import React, { useState } from 'react'
import { REQUEST_FORGOT_PASSWORD } from '../Utils/apis';
const useRequestForgotPassword = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [sucess, setSucess] = useState(false);


    const fn = async (email) => {
        if (!loading) {
            try {
                setError('');
                setLoading(true)
                const res = await fetch(REQUEST_FORGOT_PASSWORD, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ email }),
                    credentials: 'include',
                });

                if (res.ok) {
                    // return Promise.resolve("Request Sended succesfully");
                    setSucess(true);
                }
                else {
                    if (res?.status === 404) {
                        // setError("User is not registered with this email")
                        throw new Error("User is not registered with this email");
                    }
                    else {
                        const err = await res.json();
                        throw new Error(err.message);
                    }
                }
            } catch (error) {
                setError(error.message);
                return Promise.reject(error.message);
            }
            finally {
                setLoading(false);
            }
        }
    }

    return [loading, error, sucess, fn];
}

export default useRequestForgotPassword;